// Auto generated file, do not manually modify!
// com.hotpads.capps.handler.web.landlord.v1.CappsUserManagementWebApiHandler

import type { QueryOptions, UseMutationOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useMutation, useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CappsUserManagementWebApiHandler_assignApplicationManager,
  CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification,
  CappsUserManagementWebApiHandler_requestApplicationPermissions,
  CappsUserManagementWebApiHandler_userManagementCompanyDetails,
  CappsUserManagementWebApiHandler_userManagementCompanyDetails_Path,
} from '@zg-rentals/ts-capps-client';

import type {
  AssignApplicationManagerRequestDto,
  UserManagementCompanyDetailsResponseDto,
} from '@zg-rentals/ts-capps-client';

export interface CappsUserManagementWebApiHandler_assignApplicationManager_Args {
  postData: AssignApplicationManagerRequestDto;
}

export type CappsUserManagementWebApiHandler_assignApplicationManager_Options = UseMutationOptions<
  void,
  unknown,
  CappsUserManagementWebApiHandler_assignApplicationManager_Args
>;

export const useCappsUserManagementWebApiHandler_assignApplicationManager = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_assignApplicationManager_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: CappsUserManagementWebApiHandler_assignApplicationManager_Args) =>
      CappsUserManagementWebApiHandler_assignApplicationManager(args.postData, httpClient),
  });
};

export type CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification_Options = UseMutationOptions<
  void,
  unknown,
  void
>;

export const useCappsUserManagementWebApiHandler_requestApplicationManagerIdVerification = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsUserManagementWebApiHandler_requestApplicationManagerIdVerification(httpClient),
  });
};

export type CappsUserManagementWebApiHandler_requestApplicationPermissions_Options = UseMutationOptions<
  void,
  unknown,
  void
>;

export const useCappsUserManagementWebApiHandler_requestApplicationPermissions = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_requestApplicationPermissions_Options, 'mutationFn'> & {
  httpClient?: Client;
} = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () => CappsUserManagementWebApiHandler_requestApplicationPermissions(httpClient),
  });
};

export type CappsUserManagementWebApiHandler_userManagementCompanyDetails_Options = UseQueryOptions<
  UserManagementCompanyDetailsResponseDto,
  unknown,
  UserManagementCompanyDetailsResponseDto,
  readonly [string]
>;

const CappsUserManagementWebApiHandler_userManagementCompanyDetails_GetKey = () =>
  [CappsUserManagementWebApiHandler_userManagementCompanyDetails_Path] as const;

export const CappsUserManagementWebApiHandler_userManagementCompanyDetails_queryOptions = ({
  httpClient,
}: { httpClient?: Client } = {}) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CappsUserManagementWebApiHandler_userManagementCompanyDetails_GetKey(),
    queryFn: () => CappsUserManagementWebApiHandler_userManagementCompanyDetails(httpClient),
  }) as const satisfies QueryOptions;

export const useCappsUserManagementWebApiHandler_userManagementCompanyDetails = ({
  httpClient,
  ...options
}: Omit<CappsUserManagementWebApiHandler_userManagementCompanyDetails_Options, 'queryFn' | 'queryKey'> & {
  httpClient?: Client;
} = {}) => {
  return useQuery({
    ...CappsUserManagementWebApiHandler_userManagementCompanyDetails_queryOptions({ httpClient }),
    ...options,
  });
};
useCappsUserManagementWebApiHandler_userManagementCompanyDetails.getKey =
  CappsUserManagementWebApiHandler_userManagementCompanyDetails_GetKey;
